<template>
<div class="article-list">
	<div class="item" v-for="item of data" :key="item.id">
		<h2>
			<span class="bedge-cjg" v-if="item.type === 1">CJG</span>
			<nuxt-link :to="`/article/detail/${item.id}`" target="_blank" rel="noopener">{{ item.title }}</nuxt-link>
			<i v-if="item.gcoins" class="iconfont icon-jinbi"></i>
			<template v-if="item.gcoins">
				<img v-if="item.isBuy" src="~assets/list-7.jpg" :alt="item.title" />
				<img v-else src="~assets/list-5.png" :alt="item.title" />
			</template>
		</h2>
		<p class="intro">{{ (item.desc ? (item.desc + ' -- ') : '') + '文章内容仅代表作者个人观点，仅供阅读交流，所有内容不构成投资建议，不作为买卖依据，据此操作风险自负!' }}</p>
		<div class="info clearfix">
			<nuxt-link class="avatar left" target="_blank" rel="noopener" :to="`/article/list/${item.userId}`">
				<img v-lazy="isSupportWebp(item.userAvatar)" :alt="item.userName" />
			</nuxt-link>
			<nuxt-link class="name left" target="_blank" rel="noopener" :to="`/article/list/${item.userId}`">{{ item.userName }}</nuxt-link>
			<p class="view left">{{ item.viewCount }}人阅读</p>
			<p class="timer left">{{ item.createAt }}</p>
		</div>
	</div>
</div>
</template>

<script>
import Webp from '@/mixins/Webp'

export default {
	mixins: [Webp],
	name: 'article-list',
	props: {
		data: {
			type: Array
		}
	}
}
</script>

<style lang="less" scoped>
.article-list {
	padding: 0 38px; border-bottom: 1px solid #eee;
	.item {
		padding: 20px 0;
		&:not(:last-child) {
			border-bottom: 1px solid #eee;
		}
		h2 {
			margin-bottom: 16px;
			.bedge-cjg {
				display: inline-block; line-height: 26px; padding: 0 10px; background: #F79900; border-radius: 13px; color: #fff; vertical-align: 10%; font-size: 16px;
			}
			.icon-jinbi {
				font-size: 20px; color: #fb9735; margin:0 5px; vertical-align: -4%;
			}
			img {
 				vertical-align: -10%;
			}
		}
		.intro {
			font-size: 14px; color: #666666; margin-bottom: 15px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; height: 38px; text-overflow:ellipsis; overflow: hidden;
		}
		.info {
			font-size: 14px; color: #999999;
			.avatar {
				width: 30px; height: 30px;
				img {
					width: 30px; height: 30px; border-radius: 50%;
				}
			}
			.name {
				margin-left: 10px; line-height: 30px;
			}
			.view,
			.timer {
				margin-left: 20px; line-height: 30px;
			}
		}
	}
}
</style>
